import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fishColors = {
  Truite: "bg-rose-100 text-rose-700",
  Brochet: "bg-emerald-100 text-emerald-700",
  Sandre: "bg-amber-100 text-amber-800",
  Carpe: "bg-orange-100 text-orange-700",
  "Black-bass": "bg-lime-100 text-lime-700",
  Perche: "bg-teal-100 text-teal-700",
  Silure: "bg-slate-200 text-slate-700",
  Bar: "bg-sky-100 text-sky-700",
  default: "bg-emerald-50 text-emerald-700",
};

export const fishBadge = (f) => fishColors[f] || fishColors.default;
